import { TextLargeParagraph } from '@carboncopyco/ui';
import { getTimezoneName } from '@carboncopyco/utils';
import { useMemo, useState } from 'react';
import { TableTabs } from '../../../../Dashboard/SessionBreakdownComponents';
import type { CsvParams } from '../../../../Dashboard/SessionBreakdownComponents/types';
import { useUrlState } from '../../../../utils';
import { DownloadCsvButton } from '../../../DownloadCsv';
import { TitleCard } from '../../../InfoPageCards/TitleCard';
import type { UrlState } from '../../../types';
import { useDemoPageProps } from '../../DemoPageContext';

import { PresentationsSessionsBreakdown } from './PresentationsSessionsBreakdown';
import { VisitsSessionsBreakdown } from './VisitsSessionsBreakdown';

export const SessionsBreakdownCard = () => {
  const { organizationId, workspaceId, demoId } = useDemoPageProps();
  const [urlState, setUrlState] = useUrlState<UrlState>({
    tab: 'presentations',
  });
  const { tab } = urlState;
  const resetState = {
    presenters: undefined,
    opportunities: undefined,
    links: undefined,
  };
  const initialCsvParams: CsvParams['params'] = useMemo(
    () => ({
      organizationId,
      resourceTypes: ['managed_presentation'],
      timezone: getTimezoneName(),
    }),
    [organizationId]
  );
  const [csvParams, setCsvParams] = useState<CsvParams>({
    params: initialCsvParams,
    isDisabled: false,
  });

  return (
    <TitleCard
      radius
      border="ds-regular"
      header={
        <div className="h-ds-15 flex px-6 items-center justify-between">
          <TextLargeParagraph
            label="Session breakdown"
            color="text-ds-natural-600"
          />
          <div className="flex gap-3 items-center">
            <TableTabs
              defaultIndex={tab === 'presentations' ? 0 : 1}
              onChange={(index) => {
                const tab = index ? 'visits' : 'presentations';
                setUrlState({ ...resetState, tab });
                setCsvParams({
                  params: {
                    ...initialCsvParams,
                    resourceTypes:
                      tab === 'presentations'
                        ? ['managed_presentation']
                        : ['shared_presentation'],
                  },
                  isDisabled: false,
                });
              }}
            />
            <DownloadCsvButton
              params={csvParams.params}
              disabled={csvParams.isDisabled}
              location="demo_info_page"
            />
          </div>
        </div>
      }
    >
      {tab === 'presentations' ? (
        <PresentationsSessionsBreakdown
          demoId={demoId}
          organizationId={organizationId}
          workspaceId={workspaceId}
          setCsvParams={setCsvParams}
        />
      ) : (
        <VisitsSessionsBreakdown setCsvParams={setCsvParams} />
      )}
    </TitleCard>
  );
};
